import { CURRENT_STATE, CURRENT_ZIP, FIRST_NAME, LAST_NAME, MIDDLE_NAME, PHONE } from '../constants/formFieldNames';
import type { PidAnswers } from '../IdvContext';
import { FieldValidator } from '../validation/validation';

export function formatPhoneNumber(phoneNumber: string) {
  const digitsOnlyPhoneNumber = phoneNumber.replace(/\D/g, '');
  return `(${digitsOnlyPhoneNumber?.slice(0, 3)}) ${digitsOnlyPhoneNumber?.slice(3, 6)}-${digitsOnlyPhoneNumber?.slice(
    6,
  )}`;
}

export function formatPidAnswersForReview(pidAnswersForReview: Omit<PidAnswers, 'dob' | 'ssn'>) {
  const formattedPidAnswersForReview = {} as Record<string, string>;

  let errors: string | null = '';
  for (const [key, value] of Object.entries(pidAnswersForReview)) {
    if (!value) {
      formattedPidAnswersForReview[key] = '';
      continue;
    }

    switch (key) {
      case FIRST_NAME: {
        errors = new FieldValidator(value)
          .maxLength(32)
          .regex(/^[ A-Za-z]+$/)
          .build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = value);
        break;
      }
      case MIDDLE_NAME: {
        errors = new FieldValidator(value)
          .maxLength(32)
          .regex(/^[ A-Za-z]+$/)
          .build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = value);
        break;
      }
      case LAST_NAME: {
        errors = new FieldValidator(value)
          .maxLength(32)
          .regex(/^[ A-Za-z]+$/)
          .build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = value);
        break;
      }
      case CURRENT_STATE: {
        errors = new FieldValidator(value).isStateOrTerritory().build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = value);
        break;
      }
      case CURRENT_ZIP: {
        errors = new FieldValidator(value.substring(0, 5)).regex(/^\d+$/).build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = value);
        break;
      }
      case PHONE: {
        const sanitizedPhoneNumber = value?.replace(/\D/g, '').substring(0, 10);
        errors = new FieldValidator(sanitizedPhoneNumber).length(10).regex(/^\d+$/).build();

        errors ? (formattedPidAnswersForReview[key] = '') : (formattedPidAnswersForReview[key] = sanitizedPhoneNumber);
        break;
      }
      default: {
        formattedPidAnswersForReview[key] = value;
        break;
      }
    }
  }

  return {
    ...pidAnswersForReview,
    ...formattedPidAnswersForReview,
    dob: '',
    ssn: '',
  };
}
